import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UserDataModel } from '@app/models/auth/userData.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { Globals } from 'globals';

@Component({
  selector: 'app-base-confirm-password-form',
  templateUrl: './base-confirm-password-form.component.html',
  styleUrls: ['./base-confirm-password-form.component.scss']
})
export class BaseConfirmPasswordFormComponent implements OnInit {
  @Input()
  templateSettings; // Passed from components such as account-settings and change-password

  passwordForm: FormGroup;
  resetPasswordSubmitted: boolean = false;
  passwordLength: number;
  formSubmitted: boolean = false;

  messageCopy: string = null;
  messageClass: string = this.globals.styles.alertClass;
  jsonData: SafeUrl;
  locale: any = {};

  constructor(
    public globals: Globals,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    public localisation: LocalisationService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('BaseConfirmPasswordComponent');

    this.passwordForm = this.formBuilder.group({
      password: [null, [Validators.required]]
    });
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  submitForm(model: UserDataModel) {
    this.resetPasswordSubmitted = true;

    if (!this.passwordForm.valid) {
      return;
    }
    this.setFormSubmitted(true);
    this.sendForm(model);
  }

  sendForm(model: any) {
    // Reset the form ready for new input
    this.setFormSubmitted(false);
    this.resetPasswordSubmitted = false;
    this.passwordForm.reset();
    this.authService.getGdprData(model).subscribe(
      succeed => {
        this.jsonData = JSON.stringify(succeed);

        this.setJsonFile(this.jsonData);
      },
      err => {
        this.messageCopy = err.returnCode.message;
        this.messageClass = this.globals.styles.errorClass;
      }
    );
  }

  setJsonFile(jsonData) {
    var data = 'data:text/json;charset=utf-8,' + encodeURIComponent(jsonData);
    var sanitizerData = this.sanitizer.bypassSecurityTrustUrl(data);
    this.jsonData = sanitizerData;
  }

  // Clear messages when input fields are active
  onClickInput() {
    this.messageCopy = null;
    this.messageClass = this.globals.styles.alertClass;
  }

  goBack() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/account/base-confirm-password-form/base-confirm-password-form.component.ts